/**
 * MinistrareIA - Follow-Up Service
 * API service for follow-up challenge sequences
 */
import api from './api';

const BASE = '/api/followups';

class FollowUpService {
  /** List all follow-ups (lightweight, no full days data) */
  async list(status = null, type = null) {
    const params = {};
    if (status) params.status = status;
    if (type) params.type = type;
    const response = await api.get(BASE, { params });
    return response.data;
  }

  /** Get follow-up by ID (full data with days/messages) */
  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data;
  }

  /** Create new follow-up */
  async create(data) {
    const response = await api.post(BASE, data);
    return response.data;
  }

  /** Update follow-up (partial) */
  async update(id, data) {
    const response = await api.put(`${BASE}/${id}`, data);
    return response.data;
  }

  /** Delete follow-up */
  async delete(id) {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  }

  /** Update status (activate, pause) */
  async updateStatus(id, status) {
    const response = await api.put(`${BASE}/${id}/status`, { status });
    return response.data;
  }

  /** Send messages for a specific day to specific recipients.
   *  forcar=true reenvia mesmo o que já foi enviado (botão "Reenviar este dia"). */
  async sendDay(id, day, recipients, isTest = false, forcar = false) {
    const response = await api.post(`${BASE}/${id}/send-day`, {
      day,
      recipients,
      is_test: isTest,
      forcar,
    });
    return response.data;
  }

  /** Get send history */
  async getHistory(id, day = null, recipient = null) {
    const params = {};
    if (day) params.day = day;
    if (recipient) params.recipient = recipient;
    const response = await api.get(`${BASE}/${id}/history`, { params });
    return response.data;
  }

  /** Reset history for a specific recipient */
  async resetHistoryByRecipient(id, phone) {
    const response = await api.delete(`${BASE}/${id}/history/recipient/${phone}`);
    return response.data;
  }

  /** Remove a recipient from the follow-up */
  async removeRecipient(id, phone) {
    const response = await api.delete(`${BASE}/${id}/recipients/${phone}`);
    return response.data;
  }

  /** Reset history for a specific day */
  async resetHistoryByDay(id, day) {
    const response = await api.delete(`${BASE}/${id}/history/day/${day}`);
    return response.data;
  }

  // ---- Participantes: situação e manutenção (22/09/2026) ----

  /** Situação de todos os participantes (dia, parado, pendências) em uma leitura */
  async listParticipantes(id) {
    const response = await api.get(`${BASE}/${id}/participantes`);
    return response.data;
  }

  /** Situação detalhada de um participante (resumo + o que o agente enxerga) */
  async situacaoParticipante(id, phone) {
    const response = await api.get(`${BASE}/${id}/participantes/${phone}/situacao`);
    return response.data;
  }

  /** Recomeçar do dia 1 (apaga o histórico da pessoa neste follow-up) */
  async reiniciarParticipante(id, phone) {
    const response = await api.post(`${BASE}/${id}/participantes/${phone}/reiniciar`);
    return response.data;
  }

  /** Colocar a pessoa no dia N hoje */
  async definirDiaParticipante(id, phone, dia) {
    const response = await api.post(`${BASE}/${id}/participantes/${phone}/dia`, { dia });
    return response.data;
  }

  /** Enviar agora o template de abertura ("responda SIM") */
  async enviarLembrete(id, phone) {
    const response = await api.post(`${BASE}/${id}/participantes/${phone}/lembrete`);
    return response.data;
  }

  /** Tentar entregar agora o material pendente */
  async entregarPendentes(id, phone) {
    const response = await api.post(`${BASE}/${id}/participantes/${phone}/entregar-pendentes`);
    return response.data;
  }
}

const followupService = new FollowUpService();
export default followupService;
